import { DialogObject } from '@/components/dialog/dialog.types';

interface getMemberDeleteObjectProps {
  action: () => void;
  toggleVisibility?: () => void;
}
export const getMemberDeleteObject = ({ action, toggleVisibility }: getMemberDeleteObjectProps): DialogObject => {
  return {
    title: 'settings.members.delete.title',
    description: '',
    actions: [
      {
        label: 'settings.members.delete.delete',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'settings.members.delete.cancel',
        onClick: () => toggleVisibility?.(),
        variant: 'secondary',
      },
    ],
  };
};
